import $ from 'jquery'

export const afterTaskUpdated = (taskId) => {
    $(document).trigger("taskManagement_taskUpdated", taskId);
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/syncCallbacks.js